import angular from 'angular';
import { loaderService, reportsDataService, ssDialogService } from 'app/services';
import { alerts, confirmDialog, actionIcon } from 'app/components/global';
import directive from './report-package-generated-package.directive';
import controller from './report-package-generated-package.controller';

export default angular
  .module('app.components.reports.packageReports.reportPackageGeneratedPackage', [
    ssDialogService,
    alerts,
    confirmDialog,
    reportsDataService,
    loaderService,
    actionIcon,
  ])
  .directive('prReportPackageGeneratedPackage', directive)
  .controller('PRReportPackageGeneratedPackageController', controller).name;

console.log('app.components.reports.packageReports.reportPackageGeneratedPackage created');
